import { Injectable, EventEmitter, Output } from '@angular/core';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { Globals } from '../globals';
import { GeneralService } from './general.service';
import { PermisoService } from './permiso.service';
import { Observable, Subject } from 'rxjs';
import { Response } from '@angular/http';

@Injectable()
export class ConfiguracionEmpresaService {

  constructor(
    private http: HttpInterceptor,
    private globals: Globals,
    private general: GeneralService,
    private permisoService: PermisoService
  ) { }
  guardarConfiguracion(model): Observable<any> {
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.permisoService.getPermisoAction('GUARDAR-CONFIGURACION-EMPRESA')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            model
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
  getConfiguracion(): Observable<any> {
    return this.permisoService.getPermisoAction('GET-CONFIGURACION-EMPRESA')
      .switchMap((controllerAction) => {
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
              idCliente: localStorage.getItem('idCliente')
            })
          )
          .map(
            (respuesta: Response) => respuesta.json()
          );
      });
  }
}
